// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__MdVuK","logout":"Sidebar_logout__rD31k"};